// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_67-6";
export var headerCell = "_67-2";
export var loadingStateContent = "_67-8";
export var rowWrapper = "_67-4";
export var stickyAggregationCell = "_67-b";
export var stickyAggregationRow = "_67-7";
export var stickyColumnCell = "_67-a";
export var stickyColumnHeaderCell = "_67-9";
export var table = "_67-1";
export var virtualRowWrapper = "_67-5";
export var virtualTableContainer = "_67-0";
export var white = "_67-3";